/**
 * Solo FAQ — optional single-open accordion behavior.
 */
(function () {
  class SoloFaq extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('.solo-faq__item'));

      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          this._items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    }
  }

  if (!window.customElements.get('solo-faq')) {
    window.customElements.define('solo-faq', SoloFaq);
  }
})();
